import { IconButton, type IconButtonProps, Tooltip } from "@chakra-ui/react";
import { Icon } from "@components/ui-kit/Icon";
import { observer } from "mobx-react-lite";

type StarButtonProps = {
  label: (starred: boolean) => string;
  isStarred: boolean;
  onClick?: (starred: boolean) => void;
} & Omit<IconButtonProps, "icon" | "onClick" | "aria-label">;

export const StarButton = observer(function StarredColumn({
  isStarred,
  isLoading,
  onClick,
  label,
  size = "sm",
  variant = "ghost",
  ...props
}: StarButtonProps) {
  return (
    <Tooltip label={label(isStarred)} placement="top">
      <IconButton
        {...props}
        aria-label={label(isStarred)}
        icon={
          <Icon
            name="star-01"
            variant={isStarred ? "solid" : "line"}
            color={isStarred ? "yellow.500" : "gray.400"}
          />
        }
        isLoading={isLoading}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onClick?.(!isStarred);
        }}
        size={size}
        variant={variant}
      />
    </Tooltip>
  );
});
